var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_21925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51813 23.9531C0.730627 23.8359 0.154064 23.2359 0.0415643 22.4109C0.0134393 22.2188 -0.000623227 19.9359 0.00875177 16.7531L0.0228143 11.4141L0.130627 11.1422C0.275939 10.7859 0.660314 10.3734 1.01656 10.1953L1.28844 10.0547H5.48375H9.67906L9.94625 10.1812C10.3166 10.3547 10.6119 10.6406 10.7947 11.0109L10.9447 11.3203V17.0156V22.7109L10.8041 22.9828C10.6259 23.3391 10.2134 23.7234 9.85719 23.8688L9.58531 23.9766L5.67125 23.9813C3.51969 23.9859 1.64938 23.9719 1.51813 23.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5031 23.9531C13.9687 23.8734 13.4719 23.5078 13.2 22.9922L13.0547 22.7109V20.0156V17.3203L13.1813 17.0531C13.3547 16.6828 13.6406 16.3875 14.0109 16.2047L14.3203 16.0547H18.5156H22.7109L22.9781 16.1859C23.325 16.3547 23.7234 16.7859 23.8688 17.1422L23.9766 17.4141V19.9687C23.9766 22.3078 23.9672 22.5422 23.8922 22.7625C23.7094 23.2875 23.3531 23.6578 22.8375 23.8688L22.5703 23.9766L18.6562 23.9812C16.5047 23.9859 14.6344 23.9719 14.5031 23.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2641 13.9031C13.7812 13.7484 13.3969 13.4062 13.1766 12.9422L13.0547 12.6797V6.98438V1.28906L13.2047 1.00312C13.3922 0.642187 13.7906 0.276562 14.1469 0.13125L14.4141 0.0234375H18.4922H22.5703L22.8375 0.13125C23.3531 0.342187 23.7094 0.7125 23.8922 1.2375C23.9719 1.4625 23.9766 1.80469 23.9766 7.03125V12.5859L23.8688 12.8578C23.7234 13.2141 23.3297 13.6359 22.9828 13.8094L22.7109 13.9453L18.5859 13.9547C15.2672 13.9641 14.4234 13.95 14.2641 13.9031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 7.92656C0.815625 7.77188 0.31875 7.32187 0.13125 6.85312L0.0234375 6.58594V4.00781C0.0234375 1.42969 0.0234375 1.42969 0.13125 1.1625C0.342187 0.646875 0.7125 0.290625 1.2375 0.107812C1.4625 0.028125 1.74844 0.0234375 5.53125 0.0234375H9.58594L9.85781 0.13125C10.2141 0.276562 10.6266 0.660938 10.8047 1.01719L10.9453 1.28906V3.98438V6.67969L10.7953 6.98906C10.6125 7.35938 10.3172 7.64531 9.94687 7.81875L9.67969 7.94531L5.55469 7.95469C3.28594 7.95937 1.37812 7.94531 1.3125 7.92656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_21925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.b0d1f20ee4d6c2f577409c22e7a9d723.svg";
export { ForwardRef as ReactComponent };